export default "__VITE_ASSET__BqtG3mJB__"